import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";

const OPTIONS = [
  { value: "style-1", label: "Estilo 1" },
  { value: "style-2", label: "Estilo 2" },
  { value: "style-3", label: "Estilo 3" },
];

export default function VisualStyleSelector({ value = "style-1", onChange, inverse = false, label = "Estilo" }) {
  return (
    <Box
      onClick={(event) => event.stopPropagation()}
      sx={{
        position: "absolute",
        top: 10,
        left: 10,
        zIndex: 30,
        p: 0.65,
        borderRadius: 999,
        bgcolor: inverse ? "rgba(12,18,24,.82)" : "rgba(255,255,255,.94)",
        border: "1px solid",
        borderColor: inverse ? "rgba(255,255,255,.18)" : "rgba(25,36,47,.12)",
        boxShadow: "0 7px 24px rgba(25,36,47,.16)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Stack direction="row" spacing={0.35} alignItems="center">
        <Typography
          variant="caption"
          sx={{
            display: { xs: "none", sm: "block" },
            px: 0.8,
            color: inverse ? "rgba(255,255,255,.72)" : "rgba(25,36,47,.58)",
            fontWeight: 900,
          }}
        >
          {label}
        </Typography>
        {OPTIONS.map((option) => {
          const selected = value === option.value;
          return (
            <Button
              key={option.value}
              type="button"
              size="small"
              onClick={() => onChange(option.value)}
              sx={{
                minWidth: 0,
                px: 1.15,
                py: 0.45,
                borderRadius: 999,
                textTransform: "none",
                fontSize: 11,
                fontWeight: 950,
                color: selected ? "#fff" : inverse ? "rgba(255,255,255,.78)" : "#19242F",
                bgcolor: selected ? "#F35A3A" : "transparent",
                "&:hover": { bgcolor: selected ? "#dc482c" : inverse ? "rgba(255,255,255,.10)" : "rgba(25,36,47,.06)" },
              }}
            >
              {option.label}
            </Button>
          );
        })}
      </Stack>
    </Box>
  );
}
